import { MessageCircle, Sparkles } from "lucide-react";
import { useApp } from "../context/AppContext";
import { waLink } from "../lib/api";

export default function MobileBookBar() {
  const { config, openBooking, bookingOpen } = useApp();
  if (bookingOpen) return null;
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 flex items-center gap-3 border-t border-white/10 bg-ink/85 px-4 py-3 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "calc(12px + env(safe-area-inset-bottom))" }}
      data-testid="mobile-book-bar"
    >
      <a
        href={waLink(config.brand.whatsapp)}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-outline h-12 w-12 !px-0 shrink-0"
        aria-label="Chat on WhatsApp"
        data-testid="mobile-whatsapp-btn"
      >
        <MessageCircle size={18} className="text-carza-lite" />
      </a>
      <button onClick={() => openBooking()} className="btn btn-primary h-12 flex-1 text-[15px]" data-testid="mobile-book-now-btn">
        <Sparkles size={16} /> Book Now
      </button>
    </div>
  );
}
